module.exports = __webpack_public_path__ + "static/media/expired.50f5148d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expired.svg
// module id = 1350
// module chunks = 1